import { Container, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/views/Sidebar/Sidebar';
import AdminSessionBanner from '@/components/layout/AdminSessionBanner';

export default function Main() {
  return (
    <Container p={0} maxW="100%" minH="100dvh" bg="#f8f9fb" display="flex" flexDirection="column">
      <AdminSessionBanner />
      <Flex w="100%" flex="1">
        <Sidebar />
        <Outlet />
      </Flex>
    </Container>
  );
}
